<!--  -->
<template>
  <div class="drawer_box">
    <div class="topallbox">
      <div class="top_box">
        <div class="account_title">账户名称：</div>
        <div><el-input v-model="account_name" placeholder="请输入账户名称" /></div>
      </div>
      <div class="top_box">
        <div class="account_title">密码：</div>
        <div><el-input v-model="pwd" placeholder="请输入密码" /></div>
      </div>
      <div v-for="item in structarr" :key="item" class="top_box">
        <div class="account_title">{{ item }}：</div>
        <div><el-input v-model="struct[item]" placeholder="请输入内容" @input="inputchage" /></div>
      </div>
      <div style="margin:20px 0px 0px 50px">
        <el-button type="success" @click="sumbit">确定</el-button>
      </div>
    </div>
    <div class="table_updatabox">
      <platetable ref="platetableview" :platformid="platform_id" />
    </div>

  </div>
</template>

<script>
import { accountstore } from '@/api/sourceMaterial.js'
import platetable from './platetable.vue'
export default {
  components: { platetable },
  data() {
    return {
      platform_id: null,
      account_name: '',
      pwd: '',
      structarr: [],
      struct: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.platform_id = item.id
      this.structarr = item.struct
      this.isHaveKey()
    },
    rule(obj) {
      for (var key in obj) {
        if (obj[key] === '') {
          return false
        }
      }
      return true
    },
    // 初始化对象
    isHaveKey() {
      this.struct = {}
      this.structarr.forEach(item => {
        this.struct[item] = ''
      })
    },
    async sumbit() {
      if (this.account_name === '') {
        this.$message({
          message: '请输入账户名称',
          type: 'error'
        })
        return
      }
      if (this.pwd === '') {
        this.$message({
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      const flagValue = this.rule(this.struct)
      if (!flagValue) {
        this.$message({
          message: '任一输入项都不能为空',
          type: 'error'
        })
      }
      await accountstore({
        platform_id: this.platform_id,
        struct_data: this.struct,
        account_name: this.account_name,
        pwd: this.pwd
      })
      this.$message({
        message: '提交成功',
        type: 'success'
      })
      this.empy()
      this.$refs.platetableview.updata(this.platform_id)
    },
    empy() {
      this.account_name = ''
      this.pwd = ''
      this.isHaveKey()
    },
    inputchage() {
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.drawer_box{
  padding-left: 20px;
  padding-right: 20px;
}
.topallbox{
    border: 1px solid #ccc;
    text-align: center;
    padding: 20px 0px;
}
.top_box{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}
.account_title{
    font-size: 14px;
    min-width: 170px;
    text-align: right;
}
.table_updatabox{
  margin-top: 30px;
}
</style>
